module.exports = __webpack_public_path__ + "static/Roboto-Bold-subset-b4bbdac2bc7f3295dd8b546f9bbf8b80.woff";